import type { JointsSlice, JointsState, ViewerSliceCreator } from "./types";

export const jointsInitialState: JointsState = {
  joints: [],
  selectedJointName: null,
};

export const createJointsSlice: ViewerSliceCreator<JointsSlice> = (set) => ({
  ...jointsInitialState,

  setJointList: (msg) =>
    set((state) => {
      state.joints = msg.joints;
    }),

  updateJointValue: (jointName, value) =>
    set((state) => {
      const joint = state.joints.find(j => j.name === jointName);
      if (joint) {
        joint.current_angle = value;
      }
    }),

  updateJointValues: (jointValues) =>
    set((state) => {
      for (const jv of jointValues) {
        const joint = state.joints.find(j => j.name === jv.name);
        if (joint) {
          joint.current_angle = jv.value;
        }
      }
    }),

  setSelectedJointName: (jointName) =>
    set((state) => {
      state.selectedJointName = jointName;
    }),
});
